import React from 'react';
import Head from 'next/head';
import BaseLayout from 'layouts/BaseLayout';
import Header from 'components/ScienceFigures/Header';
import MainContent from 'components/ScienceFigures/MainContent';
import { COLOR_WHITE } from 'styles/variables/colors';
import { withTranslations } from 'utils/withTranslations';

const schemeData = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What are scientific figures?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Scientific figures are a creative way to communicate the results of scientific research through a visual resource. Its a manner to present science in an accessible, useful, easy - to - understand style to allow more people to connect with science.',
      },
    },
    {
      '@type': 'Question',
      name: 'How do you make good scientific figures?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'To make good scientific figures youll need to define your goals and audience, set a strong brief, and know what is the main data and what is the most important information that your readers need to understand to create self-explanatory science figures, understandable only by reading, without an extra explanation or content.',
      },
    },
    {
      '@type': 'Question',
      name: 'What should a good scientific figure include?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Good scientific figures include a combination of text, visuals, and design, complementing each other, to improve reading comprehension. Good scientific figures show all relevant information about the research in a clear and visually pleasing way so that the reader can understand it for himself.',
      },
    },
    {
      '@type': 'Question',
      name: 'Where can I make scientific figures?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Mind The Graph is the best free platform for making scientific figures. This way, you ensure that your scientific figures have images with a consistent art style, scientifically accurate illustrations, templates with an intuitive reading flow, graphics, symbols, icons, and appropriate font styles. You can also publish your scientific figures designed with Mind The Graph in journals, magazines, blogs, social media, books, and more!',
      },
    },
  ],
};

export default function ScienceFigures() {
  return (
    <BaseLayout
      bgBrandColor={COLOR_WHITE}
      typeBtn="buttonSecondary"
      headerWhite={true}
      hasPadding={false}
      hero={<Header />}
    >
      <Head>
        <title>Create Effective Science Figures in Minutes | Mind the Graph</title>

        <meta
          key="description"
          name="description"
          content="Illustrate any topic or subject you need. Browse through the world's largest scientifically accurate illustration gallery - curated by scientists."
        />

        <meta
          name="keywords"
          content="science figures, online science figures, science figures software, illustrator science figures, create science figures, making science figures"
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemeData) }}
        />
      </Head>

      <MainContent />
    </BaseLayout>
  );
}

export const getStaticProps = withTranslations(['pricing', 'common']);
